<template>
  <div class="entry-list-by-group">
    <div class="top-add-wrap">
      <div class="top-add-btn" @click="onAddTeam">新建球队</div>
    </div>
    <van-pull-refresh v-model="loading" @refresh="fetchList">
      <div v-if="list.length > 0" class="list">
        <div class="title">{{ groupName }}已报名球队</div>
        <div
          v-for="item in list"
          :key="item.id || item.teamId"
          class="item"
          @click="goDetail(item)"
        >
          <div class="logo" v-if="item.badge">
            <img :src="imageView(item.badge)" alt="" />
          </div>
          <div class="main">
            <div class="name-row">
              <span class="team-name">{{ item.name || '-' }}</span>
            </div>
            <div class="status" :class="statusClass(item)">{{ statusText(item) }}</div>
            <div v-if="item.auditStatus === -1 && item.auditRemark" class="reject-reason">
              退回理由：{{ item.auditRemark }}
            </div>
          </div>
          <div class="item-action">
            <span class="link" @click.stop="goDetail(item)">查看详情</span>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无报名" />
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, PullRefresh, Empty, Button, Icon } from 'vant'
import { getMatchTeamListByUser } from '@/api/match'
import { QNImageUtil } from '@/utils'

Vue.use(NavBar).use(PullRefresh).use(Empty).use(Button).use(Icon)

export default {
  name: 'EntryListByGroup',
  data() {
    return {
      unionMatchId: '',
      matchId: '',
      unitType: 0,
      loading: false,
      list: [],
      groupName: ''
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.matchId = this.$route.query.matchId || ''
    this.unitType = Number(this.$route.query.unitType) || 0
    this.groupName = this.$route.query.groupName || ''
    this.fetchList()
  },
  methods: {
    imageView(img) {
      return img ? QNImageUtil.imageView(img) : ''
    },
    statusText(item) {
      if (item.isSubmit === 0) return '未提交'
      if (item.auditStatus === 0 || item.auditStatus === 1) return '待审核'
      if (item.auditStatus === 2 || item.auditStatus === 3) return '审核通过'
      if (item.auditStatus === -1) return '审核退回'
      return '待审核'
    },
    statusClass(item) {
      if (item.isSubmit === 0) return 'status-0'
      if (item.auditStatus === -1) return 'status-reject'
      if (item.auditStatus === 2 || item.auditStatus === 3) return 'status-ok'
      return 'status-pending'
    },
    fetchList() {
      this.loading = true
      getMatchTeamListByUser({
        unionMatchId: this.unionMatchId,
        role: 1,
        orderIndex: 0
      }).then(res => {
        const data = (res && res.data) || {}
        const fullList = data.list || []
        this.list = fullList.filter(item => String(item.matchId) === String(this.matchId))
      }).finally(() => {
        this.loading = false
      })
    },
    goDetail(item) {
      if (item.unitType === 1) {
        this.$router.push(`/entry-page/person-info?unionMatchId=${this.unionMatchId}&matchId=${item.matchId}&teamId=${item.teamId}`)
      } else {
        this.$router.push(`/entry-page/entry-info?unionMatchId=${this.unionMatchId}&matchId=${item.matchId}&teamId=${item.teamId}`)
      }
    },
    onAddTeam() {
      if (this.unitType === 0) {
        this.$router.push(`/entry-page/entry-info-team?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}`)
      } else if (this.unitType === 1) {
        this.$router.push(`/entry-page/entry-info-person?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}`)
      } else {
        this.$router.push(`/entry-page/entry-info-more?unionMatchId=${this.unionMatchId}&matchId=${this.matchId}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.entry-list-by-group {
  min-height: 100vh;
  background: #f6f6f8;
  padding: 12px 16px 24px;
  box-sizing: border-box;
}
.top-add-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  margin-top: 42px;
}
.top-add-btn {
  width: 230px;
  height: 54px;
  border-radius: 5px;
  background: #FFFFFF;
  box-sizing: border-box;
  border: 1px solid var(--bg3);
  color: var(--bg3);
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
.list {
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #606266;
    margin-bottom: 12px;
    margin-top: 36px;
  }
  .item {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    margin-top: 12px;
    padding: 14px 16px;
    .logo {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      background: #e8e8e8;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .main {
      flex: 1;
      min-width: 0;
      margin-left: 12px;
    }
    .name-row {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      .team-name {
        font-size: 15px;
        font-weight: 500;
        color: #1d2129;
      }
    }
    .item-action {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 12px;
    }
    .link {
      font-size: 14px;
      color: var(--bg3);
    }
    .status {
      font-size: 13px;
      &.status-0,
      &.status-pending {
        color: #606266;
      }
      &.status-ok {
        color: #0fac7f;
      }
      &.status-reject {
        color: #bc2d2f;
      }
    }
    .reject-reason {
      margin-top: 6px;
      font-size: 12px;
      color: #bc2d2f;
      line-height: 18px;
    }
  }
}
</style>
